import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ToggleReseller, ToggleResellerVariables } from '@/graphql/contracts/_generated_/toggleReseller.mutation';
import ToggleResellerMutation from '@/graphql/contracts/toggleReseller.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useToggleReseller(contractId: UUID) {
  const [_toggleReseller, { loading }] = useMutation<ToggleReseller, ToggleResellerVariables>(
    ToggleResellerMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: ({ toggleReseller }) => {
        const state = toggleReseller.reseller ? 'enabled' : 'disabled';

        notificationService.open({
          title: 'Reseller',
          text: `Reseller successfully ${state}`,
          type: 'success'
        });
      }
    }
  );

  const toggleReseller = (reseller: boolean) => {
    _toggleReseller({
      variables: {
        contractId,
        reseller
      }
    });
  };

  return {
    toggleReseller,
    isLoadingToggleReseller: loading
  } as const;
}
